:host {
  --spw-mosaic-item-width-mobile: 100%;
  --spw-mosaic-item-width-tablet: 100%;
  --spw-mosaic-item-width-desktop: 100%;

  width: var(--spw-mosaic-item-width-mobile);
  @apply spw-tw-px-3 spw-tw-mb-6;
}

@media (min-width: 768px) {
  :host {
    width: var(--spw-mosaic-item-width-tablet);
  }
}

@media (min-width: 1024px) {
  :host {
    width: var(--spw-mosaic-item-width-desktop);
  }
}

@for $i from 1 through 12 {
  .spw-mobile-#{$i} {
    --spw-mosaic-item-width-mobile: calc(100% / #{$i});
  }

  .spw-tablet-#{$i} {
    --spw-mosaic-item-width-tablet: calc(100% / #{$i});
  }

  .spw-desktop-#{$i} {
    --spw-mosaic-item-width-desktop: calc(100% / #{$i});
  }
}
